<!--
  File name: App.js
    Program Description:
    - This is the main vue file of the system that renders all the templates of
    the page.
-->

<template>
  <v-app id="inspire">
    <template v-if="sessionExists">
      <router-view
        @alert="showAlert($event)"
        @dialog="showDialog($event)"
      />
    </template>
    <Alert
      id="alert-id"
      :show="$data.$meta.alert.show"
      :message="$data.$meta.alert.message"
      :type="$data.$meta.alert.type"
      @update:show="$data.$meta.alert.show = $event"
    />
    <Alert
      id="alert-id-2"
      :show="alert.show"
      :message="alert.message"
      :type="alert.type"
      :list="alert.list"
      :with-image="true"
      :email="alert.email"
      style="z-index: 203"
      @update:show="alert.show = $event"
    />
    <v-overlay :value="alert.show" />
    <v-overlay
      :value="!sessionExists"
      z-index="10"
    >
      <v-progress-circular
        v-show="!sessionExists"
        :size="70"
        :width="6"
        indeterminate
        color="primary"
      />
    </v-overlay>
    <Dialog
      id="dialog-id"
      v-model="dialog.show"
      v-bind="dialog"
      :persistent="true"
    />
  </v-app>
</template>

<script>

import alertMixin from '@/mixins/alertMixin'
import Dialog from '@/components/Dialog'
import Alert from '@/components/Alert'
import { mapGetters, mapActions } from 'vuex'
import { socket, authSocket } from '@/socket'
import '@/locals/crudFormComponents'

export default {
  name: 'App',
  components: {
    Alert,
    Dialog
  },
  mixins: [alertMixin],
  data: () => ({
    hasPreExpireMessage: false,
    showingExpireMessage: false,
    sessionExists: false,
    triggerTimeout: null
  }),
  computed: {
    ...mapGetters({
      alert: 'getAlert',
      dialog: 'getDialog'
    }),
    ...mapGetters('session', [
      'triggerSessionState'
    ])
  },
  watch: {
    async 'alert.show' (val) {
      if (!val) {
        this.alert.callback && this.alert.callback()
      }
    },
    triggerSessionState: async function () {
      await this.$s.ready
      if (this.$s.userRole.includes('guest')) return
      this.$s.refresh()
    }
  },
  async created () {
    await this.$s.ready
    this.sessionExists = true
    authSocket.on('disconnect', () => {
      socket.connect()
    })
  },
  mounted () {
    window.addEventListener('click', this.refreshSession)
    window.addEventListener('keyup', this.refreshSession)
    this.refresh()
  },
  beforeDestroy () {
    window.removeEventListener('click', this.refreshSession)
    window.removeEventListener('keyup', this.refreshSession)
  },
  beforeUpdate () {
    this.setSessionExpirationWarning()
  },
  methods: {
    ...mapActions('session', [
      'refresh'
    ]),
    // a method that refreshes session
    async refreshSession ({ code }) {
      clearTimeout(this.triggerTimeout)
      this.triggerTimeout = setTimeout(async () => {
        if (!(!code || code === 'Space')) return
        await this.$s.ready
        if (this.$s.userRole.includes('guest')) return
        this.refresh()
        this.$s.create()
      }, 3000)
    },
    // dispatches expiration warning
    async setSessionExpirationWarning () {
      const self = this
      if (!self.hasPreExpireMessage) {
        self.$s.beforeExpire.push(() => {
          self.showingExpireMessage = true
          this.$store.dispatch('showAlert', {
            message: 'Your session is about to expire. Close this warning to refresh your session.',
            type: 'error',
            callback: () => {
              self.showingExpireMessage = false
              self.$data.$meta.alert.message = ''
              self.$s.refresh()
            }
          })
        })
        self.hasPreExpireMessage = true
      }
    }
  }

}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.v-alert {
  position: fixed !important;
  top: 30%;
  margin: auto;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
}

.v-application {
  font-family: 'Source Sans Pro';
}

.v-application a {
  text-decoration: none;
  color: inherit !important;
}

.v-stepper,
.v-dialog,
.v-list,
.v-menu__content {
  border-radius: 0 !important;
}

.v-chip--disabled {
  opacity: 1;
}

main {
  background: #d0d3d9;
}

.v-input--is-readonly.v-select .v-input__icon.v-input__icon--append,
.v-input--is-readonly.v-select .v-input__icon.v-input__icon--clear{
  display: none !important;
}

.v-card__title {
  word-break: normal !important;
}

.required-field .v-label::after {
  content: '*';
  color: #e74c3c;
  margin-left: 5px;
}

.theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
  color: black;
}
</style>
